import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

const ProductImage = ({
  advanceImage, backImage, currentImage, imageStyle,
}) => (
  <>
    <img
      className={imageStyle}
      src={currentImage}
      alt=''
    />
    <div className='carrousel-control'>
      <Icon
        className='icon'
        size='large'
        name='arrow left'
        onClick={backImage}
      />
      <Icon
        className='icon'
        size='large'
        name='arrow right'
        onClick={advanceImage}
      />
    </div>
  </>
);

ProductImage.propTypes = {
  advanceImage: PropTypes.func,
  backImage: PropTypes.func,
  currentImage: PropTypes.string,
  imageStyle: PropTypes.string,
};

export default ProductImage;
